const getDuration = (duration, adDuration, eventDurationSeconds, currentCouchTagDuration, isCouch, playerIsAdMode, playerIsAdModeIdle) => {
	if (playerIsAdModeIdle && eventDurationSeconds) {
		return eventDurationSeconds;
	}
	if (playerIsAdMode) {
		return adDuration;
	}
	if (isCouch) {
		return currentCouchTagDuration;
	}
	return duration;
};

export const getPlayerControlsProps = ({
	playerControlsUiConfig = {},
	airPlayConfig = {},
	isLookingBackInLiveEvent = false,
	isConsideredLive = false,
	playerIsAdMode = false,
	playerIsAdModeIdle = false,
	eventDurationSeconds = 0,
	duration = 0,
	mediaDuration = 0,
	position = 0,
	adDuration = 0,
	adPosition = 0,
	currentCouchTagDuration = 0,
	currentCouchTagElapsed = 0,
	isPlaying = false,
	isCouch = false,
	isFullscreen = false,
	isTouchDevice = false,
	isMobileWebApp = false,
	isEmbedded = false,
	isCinemaMode = false,
	playerSpeedOptions = [],
	currentSpeed = 1,
	currentCouchTagNumber = 0,
	couchTagsCount = 0,
	currentCouchTag = null,
	currentCouchTagLikes = 0,
	isLikedByUser = false,
	audioTracks = [],
	currentAudioTrackId = null,
	subtitleTracks = [],
	currentSubtitleTrackId = -1,
	playerQualityLevels = [],
	volumeLevel = 0,
	isMuted = false,
	scrubberDragging = false,
	storedQualityLevelId = null,
	showBorder = false,
	isSidebarOpen = true,
}) => {
	return {
		showReplay:               playerControlsUiConfig.replay.enabled,
		showTimeDisplay:          playerControlsUiConfig.timeDisplay.enabled,
		showDuration:             playerControlsUiConfig.timeDisplay.duration.enabled,
		showTimeline:             playerControlsUiConfig.timeline.enabled,
		timelinePlacement:        playerControlsUiConfig.timeline.placement,
		timelineFullWidth:        playerControlsUiConfig.timeline.fullWidth,
		showSidebarToggle:        playerControlsUiConfig.toggleSidebar.enabled,
		showScrubber:             playerControlsUiConfig.timeline.scrubber.enabled,
		isSeekable:               playerControlsUiConfig.timeline.isSeekable,
		showShareButton:          playerControlsUiConfig.shareButton.enabled,
		isPlaybackSpeedEnabled:   playerControlsUiConfig.playbackSpeed.enabled,
		isQualitySettingsEnabled: playerControlsUiConfig.qualitySettings.enabled,
		showCinemaMode:           playerControlsUiConfig.cinemaMode.enabled,
		showFullscreen:           playerControlsUiConfig.fullscreen.enabled,
		showPictureInPicture:     playerControlsUiConfig.pictureInPicture.enabled,
		showTagNavigation:        playerControlsUiConfig.tagNavigation.enabled,
		showLikeButton:           playerControlsUiConfig.likeButton.enabled,
		showReload:               playerControlsUiConfig.reload.enabled,
		showVolumeSelector:       playerControlsUiConfig.volumeControl.volumeSlider.enabled,
		showLiveBadge:            playerControlsUiConfig.badgeLive.enabled,
		isChromecastAvailable:    playerControlsUiConfig.chromecast.enabled,
		airPlayConfig:            playerControlsUiConfig.airPlay.enabled ? airPlayConfig : {},
		showPlayToggle:           playerControlsUiConfig.playToggle.enabled,
		stopEnabled:              playerControlsUiConfig.playToggle.stop.enabled,
		pauseEnabled:             playerControlsUiConfig.playToggle.pause.enabled,
		showClientLogo:           playerControlsUiConfig.clientLogo.enabled,
		clientLogoTargetURL:      playerControlsUiConfig.clientLogo.targetURL,
		showSettingsAtTop:        playerControlsUiConfig.showSettingsAtTop,
		controlsFullWidth:        playerControlsUiConfig.controlsFullWidth,
		// Stateful props
		isLookingBackInLiveEvent: isLookingBackInLiveEvent,
		isLive:                   isConsideredLive,
		duration:                 getDuration(duration, adDuration, eventDurationSeconds, currentCouchTagDuration, isCouch, playerIsAdMode, playerIsAdModeIdle),
		mediaDuration:            mediaDuration,
		position:                 playerIsAdMode
			? adPosition
			: isCouch
				? currentCouchTagElapsed
				: position,
		isFullscreen:           isFullscreen,
		isPlaying:              isPlaying,
		isTouchDevice:          isTouchDevice,
		isMobileWebApp:         isMobileWebApp,
		isEmbeddedMode:         isEmbedded,
		isCinemaMode:           isCinemaMode,
		currentSpeed:           currentSpeed,
		audioTracks:            audioTracks,
		currentAudioTrackId:    currentAudioTrackId,
		subtitleTracks:         subtitleTracks,
		currentSubtitleTrackId: currentSubtitleTrackId,
		qualityLevels:          playerQualityLevels,
		volumeLevel:            volumeLevel,
		isMuted:                isMuted,
		scrubberDragging:       scrubberDragging,
		isSidebarOpen:          isSidebarOpen,
		// other props
		storedQualityLevelId:   storedQualityLevelId,
		playerSpeedOptions:     playerSpeedOptions,
		showBorder:             showBorder,
		// couch specific props
		currentTagNumber:       currentCouchTagNumber,
		tagsCount:              couchTagsCount,
		currentTag:             currentCouchTag,
		likes:                  currentCouchTagLikes,
		isLiked:                isLikedByUser,
	};
};
